import React from "react";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
  BusinessOutlined,
  ContactPhoneOutlined,
  DoubleArrow,
  FlagOutlined,
  MailOutline,
  OpenInNewOutlined,
  ReceiptLongOutlined,
} from "@mui/icons-material";
import {
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SceneBox from "components/SceneBox";
import { useNavigate } from 'react-router-dom';

export default function SalesHub() {
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const navigate = useNavigate();
  
  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="SALES" subtitle="Salesmate" />
        <Box>
        </Box>
      </FlexBetween>

      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 1 */}
        <SceneBox
          value="Go to site"
          onClick={() => {
                window.open("https://flairflow.salesmate.io");
              }}
          icon={
            <OpenInNewOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Deals"
          onClick={() => {
                navigate("/sales/deals");
              }}
          icon={
            <ReceiptLongOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Contacts"
          onClick={() => {
                navigate("/sales/contacts");
              }}
          icon={
            <ContactPhoneOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Companies"
          onClick={() => {
                navigate("/sales/companies");
              }}
          icon={
            <BusinessOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Activities"
          onClick={() => {
                navigate("/sales/activities");
              }}
          icon={
            <BusinessOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="Database"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        <SceneBox
          value="Leads"
          onClick={() => {
                window.open('https://docs.google.com/spreadsheets/d/1PhoRZBZTyypGhiikND_khr1YPi8GShz3jIvhRAz-y3k/edit?usp=sharing');
              }}
          icon={
            <FlagOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        /></Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="Star of Service"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 2 */}
        <SceneBox
          value="Opportunité"
          onClick={() => {
                window.open('https://www.starofservice.com/pro/opportunites');
              }}
          icon={
            <FlagOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Message"
          onClick = {() => {
              window.open('https://www.starofservice.com/pro/messenger');
            }}
          icon={
            <MailOutline
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
      <FlexBetween marginTop={5}>
        <Header title="" subtitle="Other Platforms"/>
      </FlexBetween>
      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 3 */}
        <SceneBox
          value="Funbooker"
          onClick={() => {
                window.open('https://www.funbooker.com/fr/funpro/tableau_de_bord');
              }}
          icon={
            <DoubleArrow
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        
        <SceneBox
          value="Mariages.net"
          onClick={() => {
                window.open('https://www.mariages.net/');
              }}
          icon={
            <DoubleArrow
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Malt.fr"
          onClick = {() => {
              window.open('https://www.malt.fr/');
            }}
          icon={
            <DoubleArrow
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="SuperProf.fr"
          onClick={() => {
                window.open('https://www.superprof.fr/');
              }}
          icon={
            <DoubleArrow
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Jemepropose"
          onClick = {() => {
              window.open('https://www.jemepropose.com/');
            }}
          icon={
            <DoubleArrow
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
    </Box>
  );
};